import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import CustomersListView from "./list";
import CustomersMembersListView from "./members";
import {CustomerMemberShipNames} from "../../../../../core/constants/enums";
import useAccessLevels from "../../../../hooks/use-access-levels";


const CustomerViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens for the changes in location and with each change:
     * If the url was [customers.base] redirects the users to the appropriate view.
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.customers.base, exact: true})) {
            if (operatorAccessLevels.packages.base.customerList) {
                history.replace(routes.customers.list);
            } else if (operatorAccessLevels.packages.base.customerMembersList) {
                history.replace(routes.customers.members.base);
            } else {
                history.replace(routes.customers.base.concat(routes.error.accessDeniedForSection));
            }
        }
        if (!!matchPath(location.pathname, {path: routes.customers.members.base, exact: true})) {
            if (!operatorAccessLevels.packages.base.customerMembersList) {
                if (operatorAccessLevels.packages.base.customerList) {
                    history.replace(routes.customers.list)
                } else {
                    history.replace(routes.customers.base.concat(routes.error.accessDeniedForSection))
                }
            }
        }
    }, [history, location, operatorAccessLevels.packages.base.customerList, operatorAccessLevels.packages.base.customerMembersList])

    return (
        <Switch>
            <Route path={routes.customers.base} exact/>
            {
                operatorAccessLevels.packages.base.customerList &&
                <Route path={routes.customers.list} exact>
                    <CustomersListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.customerMembersList &&
                <Route path={routes.customers.members.activeMembers} exact>
                    <Redirect
                        to={{
                            pathname: routes.customers.members.base,
                            search: `?tab=${encodeURIComponent(CustomerMemberShipNames.active)}`,
                        }}
                    />
                </Route>
            }
            {
                operatorAccessLevels.packages.base.customerMembersList &&
                <Route path={routes.customers.members.inactiveMembers} exact>
                    <Redirect
                        to={{
                            pathname: routes.customers.members.base,
                            search: `?tab=${encodeURIComponent(CustomerMemberShipNames.deactivated)}`,
                        }}
                    />
                </Route>
            }
            {
                operatorAccessLevels.packages.base.customerMembersList &&
                <Route path={routes.customers.members.passiveMembers} exact>
                    <Redirect
                        to={{
                            pathname: routes.customers.members.base,
                            search: `?tab=${encodeURIComponent(CustomerMemberShipNames.onHold)}`,
                        }}
                    />
                </Route>
            }
            {
                operatorAccessLevels.packages.base.customerMembersList &&
                <Route path={routes.customers.members.base} exact>
                    <CustomersMembersListView/>
                </Route>
            }
            <Redirect to={routes.customers.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default CustomerViews;
